// Light / dark appearance. The palette lives in CSS variables (index.css:
// `:root` for light, `.dark` for dark) that tailwind.config.js reads, so a
// class on <html> restyles everything. The choice is per device, kept in
// localStorage, and applied only while the dashboard is mounted: the
// landing and sign-in pages stay light.
import { useEffect, useState } from "react";

const KEY = "vaulzo-theme";
const THEMES = ["light", "dark"];
const listeners = new Set();

export function getTheme() {
  try {
    const t = localStorage.getItem(KEY);
    return THEMES.includes(t) ? t : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
}

export function setTheme(theme) {
  if (!THEMES.includes(theme)) return;
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // private window: the choice lasts for the session only
  }
  applyTheme(theme);
  listeners.forEach((fn) => fn(theme));
}

/** [theme, setTheme] — every subscriber re-renders when the choice changes. */
export function useTheme() {
  const [theme, set] = useState(getTheme);
  useEffect(() => {
    listeners.add(set);
    return () => listeners.delete(set);
  }, []);
  return [theme, setTheme];
}
